export const caAmountTooltips = {
  maxDailyAmount:
    "The largest amount of this material that could be on site at any one time during the year. California regulations state that this amount cannot be less than the total capacity of the container(s) or tank(s) holding it. Containers should be reported as full even if they are rarely or never filled to that level. Applies to both hazardous materials and hazardous wastes.",
  averageDailyAmount:
    "The average amount of this material on site over the year. Add up the daily amounts for each day the material was present, then divide by the number of days it was present on site. For a material not previously stored here, estimate the average daily amount you expect over the course of the year.",
  maxAmountLargestContainer:
    "Defined in California regulations as the total capacity of the largest single container or tank in which this material is stored. Report the largest container's full capacity, not the amount of material actually inside it.",
} as const;

export type CaAmountTooltipField = keyof typeof caAmountTooltips;

export function getCaAmountTooltip(
  state: string | null | undefined,
  field: CaAmountTooltipField
): string | undefined {
  if (state !== "CA") {
    return undefined;
  }

  return caAmountTooltips[field];
}
